import { render } from "./EventComponent.vue?vue&type=template&id=f56ebc52"
import script from "./EventComponent.vue?vue&type=script&lang=js"
export * from "./EventComponent.vue?vue&type=script&lang=js"

import "./EventComponent.vue?vue&type=style&index=0&id=f56ebc52&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__